/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDeliveryParcels200ResponseAllOfData } from './GetDeliveryParcels200ResponseAllOfData';
import {
    GetDeliveryParcels200ResponseAllOfDataFromJSON,
    GetDeliveryParcels200ResponseAllOfDataFromJSONTyped,
    GetDeliveryParcels200ResponseAllOfDataToJSON,
} from './GetDeliveryParcels200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetDeliveryParcels200ResponseAllOf
 */
export interface GetDeliveryParcels200ResponseAllOf {
    /**
     * 
     * @type {GetDeliveryParcels200ResponseAllOfData}
     * @memberof GetDeliveryParcels200ResponseAllOf
     */
    data: GetDeliveryParcels200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetDeliveryParcels200ResponseAllOf interface.
 */
export function instanceOfGetDeliveryParcels200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetDeliveryParcels200ResponseAllOfFromJSON(json: any): GetDeliveryParcels200ResponseAllOf {
    return GetDeliveryParcels200ResponseAllOfFromJSONTyped(json, false);
}

export function GetDeliveryParcels200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryParcels200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetDeliveryParcels200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetDeliveryParcels200ResponseAllOfToJSON(value?: GetDeliveryParcels200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetDeliveryParcels200ResponseAllOfDataToJSON(value.data),
    };
}

